<template>
    <div>
        <v-container grid-list-xl pt-0>
            <page-tool-bar show_search show_date_start show_date_end :loading="loader" :search.sync="search"
                :date_start.sync="date_start" :date_end.sync="date_end">
                <v-flex xs12 md2>
                    <v-select label="Trạng thái" :disabled="loader" v-model="repair_request_status"
                        :items="[...repair_request_status_options, 'Tất cả']" item-text="name" item-value="name"
                        hide-details></v-select>
                </v-flex>
                <v-flex xs12 md2>
                    <v-select label="Thợ sửa chữa" :disabled="loader" v-model="repairman_name"
                        :items="[...repairmen_name, 'Tất cả']" hide-details></v-select>
                </v-flex>
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="download_csv_count++" color="primary" dark>XUẤT EXCEL</v-btn>
                        <dialog-tao-phieu-sua-chua :repairmen_name="repairmen_name" @reloadTable="reload_table++"></dialog-tao-phieu-sua-chua>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <table-phieu-sua-chua
                            @onDialogRepairTimesheetSubmitted="$emit('onDialogRepairTimesheetSubmitted')"
                            :repair_request_status="repair_request_status" :repairman_name="repairman_name" 
                            :repairmen_name="repairmen_name" :date_start="date_start" :date_end="date_end"
                            :search="search" :reload_table="reload_table" :loader.sync="loader" 
                            :download_csv_count="download_csv_count"></table-phieu-sua-chua>
                    </v-card>
                </v-flex>
            </v-layout>

        </v-container>
    </div>
</template>

<script>

import DialogTaoPhieuSuaChua from "./DialogTaoPhieuSuaChua"
import TablePhieuSuaChua from "./TablePhieuSuaChua"
import moment from 'moment'
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton'
import { REPAIR_REQUEST_STATUS } from "../../constants/db-config"
import api from "Api";
import { buildParamQuery } from "Helpers";

export default {
    name: "phieu-sua-chua-layout",
    components: {
        DialogTaoPhieuSuaChua,
        TablePhieuSuaChua,
        ExportCsvButton
    },
    data() {
        return {
            reload_table: 0,
            download_csv_count: 0,
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substring(0, 10),
            loader: false,
            search: "",
            REPAIR_REQUEST_STATUS,
            repair_request_status: "Tất cả",
            repairman_name: "Tất cả",
            repairmen_name: []
        }
    },
    computed: {
        repair_request_status_options(){
            return Object.values(this.REPAIR_REQUEST_STATUS);
        },
    },
    mounted() {
        this.reload_table++
        this.getRepairmenName();
    },
    methods: {
        async getRepairmenName() {
            console.log(121);
            const params = {};
            const query = buildParamQuery(params)
            const response = await api.getRepairmen(query);
            if (response.status === 200) {
                this.repairmen_name = response.data.map(item => {
                    return item.name;
                });
            }
        }
    },
    watch: {
        date_start() {
            this.reload_table++
        },
        date_end() {
            this.reload_table++
        },
        repairman_name() {
            this.reload_table++
        }
    }
}
</script>

<style></style>